















import { computed, defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'Input',
    components: {},
    props: {
        value: {
            type: [String, Number],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        },
        suffix: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
    },
    setup(props, context) {
        const handleInput = (e: Event) => {
            // @ts-ignore
            let value = e.target.value;
            if (value.includes(props.suffix)) {
                value = value.replace(props.suffix, '');
            }
            if (value === String(props.value)) {
                // 删除了suffix
                value = value.slice(0, -1);
            }
            context.emit('input', value);
        };
        const formatValue = computed(() => props.value && props.value + props.suffix);
        return {
            handleInput,
            formatValue,
        };
    },
});
